<div class="mx-auto w-full h-auto border-black border-2 rounded-md">
	@if (!disabled()) {
		<ara-editor-menu [editor]="editor"></ara-editor-menu>
	}
	<div
		tiptap
		[editor]="editor"
		[(ngModel)]="_model"
		(ngModelChange)="sendValue()"
		[disabled]="disabled()"
		[style]="disabled() ? 'background: lightgrey;' : ''"></div>
</div>
